import useSearchParameters from '../../Components/Navigation/Hooks/useSearchParametersHook';
import UserDataManagement from './UserDataManagement';
import UserDataUpload from './UserDataUpload';

const UserDataPage: React.FC = () => {
    const [searchParamters] = useSearchParameters();

    const showUpload = searchParamters.show === 'Upload';
    const showManagement = !showUpload || searchParamters.show === 'Management';

    return (
        <div data-track="UserDataPage">
            {showUpload && <UserDataUpload />}
            {showManagement && <UserDataManagement />}
        </div>
    );
};
export default UserDataPage;
